import * as PIXI from 'pixi.js'
import { labelTypesWebGL } from '@/config'
import Tool from './tool.class'
import { clear } from '../utils'

export default class DrawLabel extends Tool {
  drawing = false
  start
  update(event, config, container, pixiObj, options, vm) {
    super.update(...arguments)
  }
  mouseDown(event) {
    this.start = event
    this.drawing = true
  }
  mouseUp(event) {
    if (this.drawing) {
      this.drawing = false
      this.sendResultData(event)
    }
  }
  mouseWheel(event) {}
  mouseMove(event) {
    if (
      this.drawing &&
      this.lineLength(
        this.start.offsetX,
        this.start.offsetY,
        event.offsetX,
        event.offsetY,
      ) > this.config.minLength
    ) {
      this.draw(
        this.start.offsetX,
        this.start.offsetY,
        event.offsetX,
        event.offsetY,
      )
    } else {
      clear(this.container)
    }
  }
  mouseLeave(event) {
    if (this.drawing) {
      this.drawing = false
      this.sendResultData(event)
    }
  }
  sendResultData(endEvent) {
    if (
      this.lineLength(
        this.start.offsetX,
        this.start.offsetY,
        event.offsetX,
        event.offsetY,
      ) > this.config.minLength
    ) {
      this.$msg({
        type: 'DRAW_LABEL',
        start: this.start,
        end: endEvent,
        options: this.options,
      })
      clear(this.container)
    }
  }
  lineLength(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2))
  }
  draw(x1, y1, x2, y2) {
    clear(this.container)
    const config = this.config
    const options = this.options
    const drawConfig = labelTypesWebGL[config.type]
    let graphic = new PIXI.Graphics()
    let text = new PIXI.Text()
    const style = drawConfig.style.default

    const startX = (x1 / options.width) * options.rootOptions.width
    const startY = (y1 / options.height) * options.rootOptions.height
    const endX = (x2 / options.width) * options.rootOptions.width
    const endY = (y2 / options.height) * options.rootOptions.height
    text.style = {
      fontFamily: 'Arial',
      fontSize: 18,
      fill: 'white',
      stroke: style.strokeStyle[0],
      strokeThickness: 2,
    }
    text.text = drawConfig.title

    switch (drawConfig.shape) {
      case 'rect':
        graphic.lineStyle(
          style.lineWidth,
          style.strokeStyle[0],
          style.strokeStyle[1],
        )
        graphic.beginFill(style.fillStyle[0], style.fillStyle[1])
        graphic.drawRect(
          startX,
          startY,
          ((x2 - x1) / options.width) * options.rootOptions.width,
          ((y2 - y1) / options.height) * options.rootOptions.height,
        )
        graphic.endFill()
        text.x = (startX < endX ? startX : endX) - 30
        text.y = (startY < endY ? startY : endY) - 30
        break
      case 'line':
        graphic.lineStyle(
          style.lineWidth,
          style.strokeStyle[0],
          style.strokeStyle[1],
        )
        graphic.moveTo(startX, startY)
        graphic.lineTo(endX, endY)
        text.x = (startY < endY ? startX : endX) - 30
        text.y = (startY < endY ? startY : endY) - 30
        break
    }

    this.container.addChild(graphic)
    this.container.addChild(text)
  }
}
